/* eslint-disable @angular-eslint/component-selector */

import { DecimalPipe, NgFor } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { BranchStockLevel, ProductListItem } from '@idealsupply/ngclient-webservice-inventory';
import { BranchService, branchAliases } from 'lib-branches';
import { Subscription } from 'rxjs';

@Component({
  selector: 'product-list-item-stock',
  templateUrl: './product-list-item-stock.component.html',
  styleUrls: ['./product-list-item-stock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgFor, DecimalPipe, MatDialogModule, MatButtonModule],
})
export class ProductListItemStockComponent implements OnDestroy {
  private subscription: Subscription = new Subscription();
  private currentBranchId?: string;
  private branchAliases: { [key: string]: string } = branchAliases;

  @Input()
  private _item?: ProductListItem;

  protected totalStock: number = 0;

  @Input()
  public get item(): ProductListItem | undefined {
    return this._item;
  }
  public set item(value: ProductListItem | undefined) {
    this._item = value;
    this._item?.stock.forEach((name) => {
      if (name.branch) {
        name.name = this.getBranchName(name.branch, name?.name);
      }
    });
    this._item?.stock.sort((a, b) => a.name.localeCompare(b.name));

    this.totalStock =
      this.item?.stock?.reduce((acc, loc) => {
        return acc + (loc.stock || 0);
      }, 0) ?? 0;
  }

  @ViewChild('stockDialogTpl', { static: true })
  private dialogTpl?: TemplateRef<any>;

  public get currentBranch(): BranchStockLevel | undefined {
    if (this.item) {
      let branch: BranchStockLevel | undefined = undefined;
      let bId = this.currentBranchId;
      branch = this.item.stock?.find((_) => {
        return _.branch === bId;
      });

      if (!branch || !branch.stock) {
        for (bId of this.branchService.defaultBranches) {
          branch = this.item.stock?.find((_) => {
            return _.branch === bId;
          });
          if (branch && branch.stock) {
            if (branch.stock < 1) {
              branch.stock = 0;
            }
            break;
          }
        }
      }

      return branch;
    }
    return undefined;
  }

  public get stock(): number {
    const stock = this.currentBranch?.stock || 0;
    return stock < 1 ? 0 : stock;
  }

  constructor(
    private branchService: BranchService,
    private changeRef: ChangeDetectorRef,
    private readonly dialogService: MatDialog,
  ) {
    this.subscription.add(
      branchService.currentBranchChange.subscribe((branchId) => {
        this.currentBranchId = branchId;
        this.changeRef.markForCheck();
      }),
    );
  }

  public getBranchName(branchId: string, branchName: string) {
    let brId = branchId.replace(/^0+/, '');
    if (brId in this.branchAliases) {
      return this.branchAliases[brId];
    }
    return branchName;
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public showPopup(): void {
    if (this.dialogTpl) {
      const dialogRef = this.dialogService.open(this.dialogTpl, {
        width: '95%',
        maxWidth: '45em',
        maxHeight: 'calc(100vh - 2rem)',
      });
    }
  }
}
